module.exports = __webpack_public_path__ + "images/lock_blackadc5caaccd1707182387fd0016072a85.svg";